import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import reportingFeedbackDetailsReducer from "./slices/feedbackDetailsSlice";
import reportingGradeDetailReducer from "./slices/gradeDetailSlice";
import reportingLessonCurriculumSlice from "./slices/lessonCurriculumSlice";
import reportingStudentsSliceReducer from "./slices/studentsSlice";
import reportingSubmitFeedbackReducer from "./slices/submitFeedbackSlice";
import reportingTermAcademicTranscriptSlice from "./slices/academicTranscriptSlice";
import reportingAssignmentDetailsSlice from "./slices/assignmentDetailsSlice";
import reportingQuizResultsSlice from "./slices/quizSlice";
import reportingGradeAcademicTranscriptSlice from "./slices/gradeAcademicTranscriptSlice";
import reportingCertificateSlice from "./slices/certificateSlice";

export { default as useReportingDispatch } from "./useReportingDispatch";
export {
    useReportingSelector,
    useStudentEntitlementsSelector
} from "./useReportingSelector";

const reportingReducerRoot = combineReducers({
    reporting: reportingStudentsSliceReducer,
    gradeDetail: reportingGradeDetailReducer,
    lessonCurriculum: reportingLessonCurriculumSlice,
    feedbackDetails: reportingFeedbackDetailsReducer,
    submitFeedback: reportingSubmitFeedbackReducer,
    academicTranscript: reportingTermAcademicTranscriptSlice,
    assignmentDetails: reportingAssignmentDetailsSlice,
    quiz: reportingQuizResultsSlice,
    gradeAcademicTranscript: reportingGradeAcademicTranscriptSlice,
    certificate: reportingCertificateSlice
});

export type ReportingRootState = ReturnType<typeof reportingReducerRoot>;

const reportingPersistConfig = {
    key: "reporting",
    storage,
    blacklist: [
        "feedbackDetails",
        "academicTranscript",
        "gradeAcademicTranscript",
        "submitFeedback",
        "reporting",
        "certificate"
    ]
};

const persistedReportingReducer = persistReducer(
    reportingPersistConfig,
    reportingReducerRoot
);

export default persistedReportingReducer;
